import { IPlacedDevice } from '../models/grid.model';
import { IDevice } from '../../shared/models/device.model';
import {
  IPragmaSpecialPlacementRulesOnKits,
  IProduct,
  IProductSupportSpecPoint,
  IUnavailablePlacement
} from '../../shared/models/product.model';
import { IStockLevel } from '../models/device-data.model';

export const getBridgeWidth = (device: IProduct): number => {
  return device?.bridge?.bridgeWidth || 0;
};

export const getOnConfigurationPlacedKits = (devices: IDevice[]): IDevice[] => {
  return devices.filter(device => device.onConfiguration === 1);
};

export const checkIncorrectPlacedUniversalDevices = (devices: IPlacedDevice[]): boolean => {
  return devices.some(queryForIncorrectDevice);
};

export const getIncorrectPlacedUniversalDevices = (devices: IPlacedDevice[]): IPlacedDevice => {
  return devices.find(queryForIncorrectDevice);
};

const queryForIncorrectDevice = placedDevice => (placedDevice?.device?.reference === null && placedDevice?.device?.enumber === 0 &&
    (placedDevice?.device?.productCharacteristicsRules?.isCustomDevice ||
    placedDevice?.device?.productCharacteristicsRules?.isCompactNsxDummy));

export const getSpecialFieldRules = (product: IProduct): IProductSupportSpecPoint[] => {
  const productSupportSpecPoints = product?.productSupportSpec.productSupportSpecPoints;
  if (!product?.kitRules?.kitWithCutOuts && !product?.kitRules?.prismaXSFieldWithSpecialRules) {
    return productSupportSpecPoints;
  }

  return productSupportSpecPoints.map((point, index) => {
    const specialFieldPlacementRules = product?.kitRules?.kitWithCutOuts ?
      getPragmaSpecialFieldRules(product?.kitRules?.pragmaSpecialPlacementRulesOnKits, index, productSupportSpecPoints.length) :
      Object.values(product?.kitRules?.prismaSpecialPlacementRulesOnKits);
    return {
      ...point,
      specialFieldPlacementRules
    };
  })
};

// eslint-disable-next-line max-len
export const getPragmaSpecialFieldRules = (pragmaSpecialFieldPlacementRules : IPragmaSpecialPlacementRulesOnKits, _: number, __: number) : IUnavailablePlacement[] => {
  return [
  pragmaSpecialFieldPlacementRules.specialPlacementRulesPmcApContactorDevices,
  pragmaSpecialFieldPlacementRules.specialPlacementRulesPmcUpContactorDevices
];
}


export const getDeviceById = (placedDevices: IPlacedDevice[], id: number): IPlacedDevice => {
  return placedDevices?.find(d => d?.id === id);
}

export const referencesWithoutPermanentlyAvailableStockLevel = (allReferences: string[],
                                                                permanentlyAvailableStockLevels: IStockLevel[]): string[] => {
  return allReferences.filter(reference =>
    permanentlyAvailableStockLevels.findIndex(stockLevel => stockLevel.productRef === reference) === -1);
}

